import React from "react";
import PropTypes from "prop-types";

import useFeatures from "components/FeatureFlag/useFeatures";
import OnboardingWidget from "components/OnboardingWidget";
import VideoGallery from "components/VideoGallery";

import {
  useBooleanState,
  useHistory,
  useOnboardingContentItemProps,
  useSnoozeContent,
} from "./hooks";

export function OnboardingContentWidget({
  title,
  welcomeMessage,
  video,
  articles,
  snoozeInDays,
}) {
  const [isDisabled, enable, disable] = useBooleanState();
  const toOnboardingItems = useOnboardingContentItemProps();
  const { isSnoozed, snooze } = useSnoozeContent();
  const history = useHistory();

  return (
    <OnboardingWidget
      title={title}
      welcomeMessage={welcomeMessage}
      items={articles.map(toOnboardingItems)}
      videoSection={video && <VideoGallery {...video} />}
      videoPosition={video?.position}
      data-test="onboarding-content-widget"
    >
      {!isSnoozed("onboarding-content") && (
        <button
          type="button"
          onClick={async () => {
            if (isDisabled) return;

            disable();
            await snooze("onboarding-content", snoozeInDays);
            enable();

            history.push("/");
          }}
          style={{
            color: isDisabled ? "grey" : "#4183C4",
            cursor: isDisabled ? "not-allowed" : "pointer",
            background: "transparent",
            border: "none",
            padding: "0",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
          }}
        >
          Dismiss onboarding training for {snoozeInDays * 24} hours
        </button>
      )}
    </OnboardingWidget>
  );
}

OnboardingContentWidget.propTypes = {
  title: PropTypes.string.isRequired,
  welcomeMessage: PropTypes.string.isRequired,
  video: PropTypes.object,
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
  snoozeInDays: PropTypes.number,
};

OnboardingContentWidget.defaultProps = { video: undefined, snoozeInDays: 3 };

function Connector() {
  const data = useFeatures("onboarding-content");

  if (!data?.articles && !data?.video?.videos) return null;

  return <OnboardingContentWidget {...data} />;
}

export default Connector;
